import { useCartContext } from "../context/CartContext";

export default function useCart() {
  const ctx = useCartContext(); // <-- vient du CartContext
  const {
    cart = [],
    addToCart,
    removeFromCart,
    updateQty,
    increment,
    decrement,
    clearCart,
    getItem,
    itemCount,
    distinctCount,
    total,
    maxQty,
    formatXOF,
    openWhatsAppCart,
  } = ctx;

  // fallback calculs si jamais itemCount ou total n’existent pas
  const totalItems = itemCount ?? cart.reduce((sum, it) => sum + (it.qty || 0), 0);
  const totalPrice = total ?? cart.reduce((sum, it) => sum + (Number(it.price) || 0) * (it.qty || 0), 0);

  return {
    cart,
    addToCart,
    removeFromCart,
    updateQty,
    increment,
    decrement,
    clearCart,
    getItem,
    itemCount: totalItems,
    distinctCount,
    total: totalPrice,
    maxQty,
    formatXOF,
    openWhatsAppCart,
  };
}
